export default __webpack_public_path__ + "static/media/ae.9ba7b7b6.svg";